import { Client, Account } from "appwrite";

class AppwriteService {
    public client
    public account

    constructor() {
        this.client = new Client().setEndpoint('https://cloud.appwrite.io/v1').setProject('66012683b6959754e8fd')
        this.account = new Account(this.client);
    }

    checkLogin =  async () => {
        try {
            const data = await this.account.get()
            return data
        } catch (error) {
            throw error
        }
    }

    login = async (email: any,password: any) => {
        try {
            await this.account.createEmailPasswordSession(email,password)
            return await this.account.get()
        } catch (error) {
            throw error
        }
    }

    logout = async () => {
        try {
            await this.account.deleteSession('current')
        } catch (error) {
            console.log(error)
        }
    }
}

export default AppwriteService